<template>
  <card class="text-center">
    <h1>404</h1>
    <h3 class="mb-4">{{ $t('page_not_found') }}</h3>

    <div class="links">
      <router-link :to="{ name: 'login' }">
        Voltar ao Início
      </router-link>
    </div>
  </card>
</template>

<script>
export default {

  middleware : 'auth',

  metaInfo () {
    return { title: 'Página não Encontrada - Erro 404' }
  },

  name: 'NotFound'
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/404.vue